import Modal from '@/components/common/modal';
import { useTranslations } from '@/i18n/use-translations';
import InviteForm from './invite.form';

export default function InviteModal({ open, close }: { open: boolean; close: () => void }) {
  const t = useTranslations();

  return (
    <Modal
      open={open}
      handleClose={close}
      title={t('organization.invite.title')}
      description={t('organization.invite.description')}
    >
      <InviteForm onCancel={close} onSuccess={close} />
    </Modal>
  );
}
